<template>
	<div class="email" v-bind:class="{ openE : email.open }">
		<h4 v-on:click="toggleOpen"><i class="fa fa-chevron-right"></i><span>{{ getHumanDate(email.mail.date ) }}</span> | Betreff: <span>{{ email.mail.subject }}</span></h4>
		<div class="mail_html" v-html="email.mail.html"></div>
	</div>
</template>
<script>
export default {
    props: ['email'],
    data() {
      return {
        FormattedDate: '',
        currentDate:  new Date(),
        yesterday: (function(d){ d.setDate(d.getDate()-1); return d})(new Date),
        //open: false
      }
    },
    methods: {
	    
	    toggleOpen: function(e){
		    this.email.open = this.email.open ? false : true; //$(e.currentTarget).parent('.email').toggleClass('openE');
        //console.log( this.email );
	    },
	    getHumanDate(dz){
		  var d = new Date( dz )
		  this.FormattedDate =  d.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' } ) + " " + d.toLocaleTimeString('de-DE'); //d.getDate() + "." + d.getMonth() + "." + d.getFullYear() + " "  + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()
		  		  
		  if( d.toLocaleDateString() == this.currentDate.toLocaleDateString() )  return 'Heute, ' + d.toLocaleTimeString('de-DE')
		  if( d.toLocaleDateString() == this.yesterday.toLocaleDateString() )  return 'Gestern, ' + d.toLocaleTimeString('de-DE')
		  return this.FormattedDate
		}
    }
}
</script>
<style>
	.email { border-top: 1px solid #ddd; font-size: 0.8rem; }
	.email > h4 { padding: 0.933333em 0; line-height: 1; cursor: pointer; position: relative; padding-left: 2em }
	.email > h4 span { font-weight: bold;  }
	.email > h4 .fa-chevron-right { position: absolute; top: 1.133333em; left:0; width: 2em; text-align: center; font-size: 0.7rem; color: rgb(64,155,233);  transition: transform 0.2s; }
	.email .mail_html { border-top: 0 solid #ddd; padding: 0; height: 0; overflow: hidden; transition: height 0.3s, padding 0.3s; padding-left: 2em !important; }

	.email.openE .fa-chevron-right { transform: rotate(90deg); }
	.email.openE .mail_html { height: auto; padding: 0.93333333em 0 2.43333333em 2em;  }
</style>



